export default __webpack_public_path__ + "static/media/expo4.e5d191de.jpg";